import { useMediaQuery } from 'react-responsive';

type BeyondBreakpoint =
  'desktopL' | 'desktopMax' | 'desktopXL' | 'desktopXXL' | 'mobile' | 'tablet';

interface BeyondBreakpointConfig {
  name: BeyondBreakpoint;
  styles: {
    height: string;
    width: string;
  };
}

export const beyondBreakpoints: BeyondBreakpointConfig[] = [
  {
    name: 'mobile',
    styles: {
      height: '800px',
      width: '360px',
    },
  },
  {
    name: 'tablet',
    styles: {
      height: '800px',
      width: '768px',
    },
  },
  {
    name: 'desktopL',
    styles: {
      height: '800px',
      width: '1024px',
    },
  },
  {
    name: 'desktopXL',
    styles: {
      height: '800px',
      width: '1280px',
    },
  },
  {
    name: 'desktopXXL',
    styles: {
      height: '800px',
      width: '1440px',
    },
  },
  {
    name: 'desktopMax',
    styles: {
      height: '800px',
      width: '1920px',
    },
  },
];

const getBreakpointStyles = (breakpointName: BeyondBreakpoint) => {
  return beyondBreakpoints.find(({ name }) => name === breakpointName)?.styles;
};

/**
 * useBreakpoint
 *
 * Hook for whenever we can’t just use CSS for breakpoint specific UIs.
 * As Beyond does not yet expose a feature matching hook for this we are pulling
 * in `react-responsive`.
 *
 * `useBeyondOnlineBreakpoints` from `@zeiss/beyond-online-react` causes
 * breakpoint conditional renders to flicker through, e.g. mobile cards on
 * desktop.
 *
 * Breakpoint definition based on:
 * {@link https://dev.azure.com/ZEISSgroup/ZDP_ODS/_git/ods.ui?path=/packages/ods-components-react/.storybook/preview.js&version=GBmain&line=3&lineEnd=4&lineStartColumn=1&lineEndColumn=1&lineStyle=plain&_a=contents}
 */

export const useBreakpoint = (name: BeyondBreakpoint) => {
  const breakpointStyles = getBreakpointStyles(name);

  return useMediaQuery({ minWidth: breakpointStyles?.width });
};
